/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MessageIcon extends BaseIcon {
    getChildren = () => [
        <g id="Group_14370" data-name="Group 14370" transform="translate(-1.439 -1)">
            <path id="Path_22646" data-name="Path 22646" d="M12.279,10.6H6.39L3.024,13.121V10.6H1.341A.841.841,0,0,1,.5,9.755V1.341A.841.841,0,0,1,1.341.5H12.279a.841.841,0,0,1,.841.841V9.755A.841.841,0,0,1,12.279,10.6Z" transform="translate(1.439 1)" fill="none" stroke={this.getColor()} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        </g>]
    getViewBox = () => '0 0 16 16'
}
